// extracted by mini-css-extract-plugin
export default {"container":"qPMmGE","responsive":"u5T_8F","header":"Ui_uny","empty":"HlW7T_","emptyContent":"pwQZhO","navButtonOutside":"_PwWpy","videoDescription":"GdM2Ug"};